import React from 'react'
import { Player } from '../../Common/SI'
import { useFilters } from '../../Common/Hooks/useFilters'

export interface PlayerNameLinkProps {
	player: Player
}

export function PlayerNameLink(props: PlayerNameLinkProps): JSX.Element {

	const { addFilter } = useFilters()

	return (
		// eslint-disable-next-line jsx-a11y/anchor-is-valid
		<a className='filter' href='#' onClick={(e) => {
			e.preventDefault()
			addFilter('players', props.player.name)
		}}>
			{props.player.name}
		</a>
	)
}
